import CardMedia from '@mui/material/CardMedia';
import { useTheme } from '@mui/material/styles';
import type { Car } from '../api/types';

/** Stands in for a car without photos: the Stututu logo in grey, one per theme. */
const PLACEHOLDER = {
  light: '/car_placeholder_light.png',
  dark: '/car_placeholder_dark.png',
} as const;

interface Props {
  car: Pick<Car, 'photo_urls' | 'display_name'>;
  height: number;
}

/** A car's first photo on a card — or the Stututu placeholder when it has none. */
export function CarCardMedia({ car, height }: Props) {
  const theme = useTheme();

  return (
    <CardMedia
      component="img"
      height={height}
      image={car.photo_urls[0] ?? PLACEHOLDER[theme.palette.mode]}
      alt={car.display_name}
    />
  );
}
